var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.911,
    height: 19.892,
    viewBox: "0 0 26.911 19.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-discord",
    d: "M25.182,9.2A12.9,12.9,0,0,0,19.011,7a.581.581,0,0,0-.578.343,3.882,3.882,0,0,0-.178.487A14.366,14.366,0,0,1,23.4,9.678a.585.585,0,1,1-.617.994,14.957,14.957,0,0,0-14.653,0,.585.585,0,0,1-.617-.994,14.359,14.359,0,0,1,5.144-1.844,4.849,4.849,0,0,0-.176-.489A.577.577,0,0,0,11.9,7,12.93,12.93,0,0,0,5.7,9.23C4.466,10.37,2,17.034,2,22.8a.587.587,0,0,0,.078.29c1.7,2.989,6.342,3.771,7.4,3.8H9.5a.584.584,0,0,0,.473-.24l1.069-1.472a11.358,11.358,0,0,1-4.445-2.086.585.585,0,0,1,.775-.878c.034.032,2.749,2.336,8.087,2.336s8.062-2.313,8.09-2.336a.585.585,0,0,1,.772.878,11.357,11.357,0,0,1-4.445,2.086l1.069,1.472a.584.584,0,0,0,.473.24h.018c1.058-.034,5.7-.816,7.4-3.8a.587.587,0,0,0,.078-.29C28.911,17.034,26.445,10.37,25.182,9.2ZM11.653,20.455a2.208,2.208,0,0,1-2.048-2.34,2.208,2.208,0,0,1,2.048-2.34,2.208,2.208,0,0,1,2.048,2.34A2.208,2.208,0,0,1,11.653,20.455Zm7.605,0a2.208,2.208,0,0,1-2.048-2.34,2.208,2.208,0,0,1,2.048-2.34,2.208,2.208,0,0,1,2.048,2.34A2.208,2.208,0,0,1,19.258,20.455Z",
    transform: "translate(-2 -6.999)",
    fill: "#191919"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.621fd0443ee55bdb3e043c607851b609.svg";
export { ForwardRef as ReactComponent };